// extracted by mini-css-extract-plugin
module.exports = {"btn":"OfferWatch_btn__YF2Hv","active":"OfferWatch_active__kLER5"};